(function ($) {
    function htmlEscape(s) {
        return String(s || '').replace(/[&<>"']/g, function (m) {
            return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m];
        });
    }

    function keepBrOnly(html) {
        return String(html || '')
            .replace(/<(?!br\s*\/?)[^>]+>/gi, '')
            .replace(/<br\s*\/?>/gi, '<br>');
    }

    // hoisted
    function ensureIcons() {
        if (typeof L === 'undefined') return null;
        if (ensureIcons._icons) return ensureIcons._icons;
        var url = (window.WBDM_MAP && WBDM_MAP.iconUrl) ? WBDM_MAP.iconUrl : null;
        if (!url) {
            if (!ensureIcons._warned) { console.warn('WBDM_MAP.iconUrl not set — using Leaflet default markers'); ensureIcons._warned = true; }
            ensureIcons._icons = null; return null;
        }
        ensureIcons._icons = {
            gold: L.icon({ iconUrl: url, iconSize:[38,58], iconAnchor:[19,58], popupAnchor:[0,-50],
                shadowUrl:'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png', shadowSize:[41,41], shadowAnchor:[13,41] }),
            goldActive: L.icon({ iconUrl: url, iconSize:[44,66], iconAnchor:[22,66], popupAnchor:[0,-56],
                shadowUrl:'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png', shadowSize:[41,41], shadowAnchor:[13,41] })
        };
        return ensureIcons._icons;
    }

    function buildPopup(m) {
        var name = '<div class="dealer-popup__name">' + htmlEscape(m.name) + '</div>';
        var addr = m.address ? '<div class="dealer-popup__address">' + keepBrOnly(m.address) + '</div>' : '';
        var contact = m.contact ? '<div class="dealer-popup__contact">' + htmlEscape(m.contact) + '</div>' : '';
        var phone   = m.phone   ? '<div class="dealer-popup__phone"><a href="tel:' + encodeURIComponent(m.phone) + '">' + htmlEscape(m.phone) + '</a></div>' : '';
        var email   = m.email   ? '<div class="dealer-popup__email"><a href="mailto:' + encodeURIComponent(m.email) + '">' + htmlEscape(m.email) + '</a></div>' : '';
        var btn = '<div class="dealer-popup__cta"><a class="dealer-popup__btn" href="' + m.gmaps + '" target="_blank" rel="noopener">Nawiguj</a></div>';
        return '<div class="dealer-popup">' + name + addr + contact + phone + email + btn + '</div>';
    }

    // keep map the same height as the sidebar (desktop only)
    function syncHeights($block, map) {
        var desktop = window.matchMedia('(min-width: 992px)').matches;
        var $wrap = $block.find('.dealer-map__wrap');
        var $canvas = $block.find('.dealer-map__canvas');
        if (!desktop) {
            $wrap.css('height', '');
            $canvas.css('height', '');
            if (map && map.invalidateSize) map.invalidateSize();
            return;
        }
        var $list = $block.find('.dealer-map__list');
        var listH = $list.outerHeight();
        if (listH && listH > 0) {
            $wrap.css('height', listH + 'px');
            $canvas.css('height', listH + 'px');
            if (map && map.invalidateSize) map.invalidateSize();
        }
    }

    function debounce(fn, ms) { var t; return function(){ clearTimeout(t); t = setTimeout(fn, ms); }; }

    function focusDealer($block, map, dict, slug) {
        var mk = dict[slug];
        if (!mk) return;

        $block.find('.dealer-map__list-item').removeClass('is-active');
        $block.find('.dealer-map__list-item[data-slug="'+ slug +'"]').addClass('is-active');

        var $select = $block.find('.dealer-map__select');
        if ($select.length) { $select.val(slug); }

        var icons = ensureIcons();
        var prev = $block.data('activeMarker');
        if (prev && prev.setIcon && icons) prev.setIcon(icons.gold);
        if (icons && mk.setIcon) mk.setIcon(icons.goldActive);
        $block.data('activeMarker', mk);

        var latlng = mk.getLatLng();
        var current = map.getZoom();
        var targetZoom = Math.min(13, Math.max(current || 0, 12));

        if (map.stop) map.stop();

        var once = function () { map.off('moveend', once); mk.openPopup(); };
        map.on('moveend', once);
        map.flyTo(latlng, targetZoom, { duration: 0.5, easeLinearity: 0.25 });

        var rect = map.getContainer().getBoundingClientRect();
        if (window.matchMedia('(max-width: 991.98px)').matches) {
            $('html, body').animate({ scrollTop: $(map.getContainer()).offset().top - 80 }, 300);
        } else if (rect.top < 0 || rect.top > (window.innerHeight * 0.25)) {
            $('html, body').animate({ scrollTop: $(map.getContainer()).offset().top - 80 }, 300);
        }
    }

    function initMap($el) {
        if (typeof L === 'undefined') { console.error('Leaflet not loaded: enqueue leaflet.js before your bundle'); return; }

        // config
        var raw = $el.attr('data-dealer-map'); var cfg = null;
        try { cfg = raw ? JSON.parse(raw) : null; } catch (e) { cfg = null; }
        if (!cfg || typeof cfg !== 'object' || !cfg.tile) {
            cfg = { tile: { url:'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', attribution:'© OpenStreetMap contributors' }, fitBounds:true, height:480, markers:[] };
        }

        ensureIcons();

        var $block  = $el.closest('.dealer-map-block');
        var $list   = $block.find('.dealer-map__list');
        var $select = $block.find('.dealer-map__select');
        var $canvas = $el.find('.dealer-map__canvas'); if (!$canvas.length) return;

        var map = L.map($canvas.get(0));
        var tile = cfg.tile || {};
        L.tileLayer(tile.url || 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: tile.attribution || '© OpenStreetMap contributors'
        }).addTo(map);

        // --- Require Ctrl/Cmd for wheel zoom ---
        map.scrollWheelZoom.disable();
        function enableWheel(){ map.scrollWheelZoom.enable(); }
        function disableWheel(){ map.scrollWheelZoom.disable(); }
        $(window)
            .on('keydown.wbdmCtrlZoom', function(e){ if (e.ctrlKey || e.metaKey) enableWheel(); })
            .on('keyup.wbdmCtrlZoom blur.wbdmCtrlZoom', function(){ disableWheel(); });
        map.on('wheel', function(e){
            var oe = e.originalEvent || e;
            if (!(oe.ctrlKey || oe.metaKey)) {
                if (oe.preventDefault) oe.preventDefault();
                disableWheel();
                showHintTemp();                 // show helper EVERY time without key
            } else {
                enableWheel();
                hideHintInstant();
            }
        });
        map.on('mouseout', function(){ disableWheel(); });

        // --- Helper overlay (Ctrl/⌘ + scroll hint) ---
        var isMac = /Mac|iPhone|iPad|iPod/i.test(navigator.platform || navigator.userAgent);
        var keyLabel = isMac ? '⌘ Cmd' : 'Ctrl';
        var $mapContainer = $(map.getContainer());
        var $hint = $('<div class="dealer-map__hint"></div>')
            .text('Przytrzymaj ' + keyLabel + ' i przewijaj, aby powiększać mapę');
        if ($mapContainer.css('position') === 'static') $mapContainer.css('position','relative');
        $mapContainer.append($hint);

        var _hintTimer = null;
        function showHintTemp(ms){
            var dur = (typeof ms === 'number') ? ms : 2800; // longer display
            $hint.addClass('is-visible');
            clearTimeout(_hintTimer);
            _hintTimer = setTimeout(function(){ $hint.removeClass('is-visible'); }, dur);
        }
        function hideHintInstant(){
            clearTimeout(_hintTimer);
            $hint.removeClass('is-visible');
        }

        // optional: gentle nudge on hover (no throttle, but don't spam if visible)
        $mapContainer.on('mouseenter', function(){
            if (!$hint.hasClass('is-visible') && !(window.event && (window.event.ctrlKey || window.event.metaKey))) {
                showHintTemp(2000);
            }
        });

        $(window).on('keydown.wbdmCtrlZoomHint', function(e){
            if (e.ctrlKey || e.metaKey) hideHintInstant();
        });
        // -------------------------------------------

        // Close popups on user zoom/drag; manage active state
        map.on('zoomstart', function(){ map.closePopup(); });
        map.on('dragstart', function(){ map.closePopup(); });
        map.on('popupopen', function (e) {
            var icons = ensureIcons();
            var mk = e.popup && e.popup._source; if (!mk) return;
            var prev = $block.data('activeMarker');
            if (prev && prev !== mk && prev.setIcon && icons) prev.setIcon(icons.gold);
            $block.data('activeMarker', mk);
            if (icons && mk.setIcon) mk.setIcon(icons.goldActive);
            $block.find('.dealer-map__list-item').removeClass('is-active');
            var slug = mk._dealerSlug || '';
            if (slug) $block.find('.dealer-map__list-item[data-slug="' + slug + '"]').addClass('is-active');
            if (slug && $select.length) $select.val(slug);
        });
        map.on('popupclose', function () {
            var icons = ensureIcons();
            var prev = $block.data('activeMarker');
            if (prev && prev.setIcon && icons) prev.setIcon(icons.gold);
            $block.removeData('activeMarker');
            $block.find('.dealer-map__list-item').removeClass('is-active');
            if ($select.length) $select.val('');
        });

        var markers = [];
        var bySlug = {};
        var icons = ensureIcons();

        (Array.isArray(cfg.markers) ? cfg.markers : []).forEach(function (m) {
            var opts = icons ? { icon: icons.gold } : {};
            var marker = L.marker([m.lat, m.lng], opts).addTo(map);
            marker.bindPopup(buildPopup(m), { maxWidth: 320 });

            if (m.slug) { bySlug[m.slug] = marker; marker._dealerSlug = m.slug; }
            markers.push(marker);

            marker.on('click', function () {
                var slug = this._dealerSlug || '';
                if (slug && bySlug[slug]) {
                    focusDealer($block, map, bySlug, slug);
                } else {
                    if (map.stop) map.stop();
                    var current = map.getZoom();
                    var targetZoom = Math.min(13, Math.max(current || 0, 12));
                    var once = function(){ map.off('moveend', once); marker.openPopup(); };
                    map.on('moveend', once);
                    map.flyTo(marker.getLatLng(), targetZoom, { duration: 0.5, easeLinearity: 0.25 });
                }
            });
        });

        if (cfg.fitBounds && markers.length) {
            var group = L.featureGroup(markers);
            map.fitBounds(group.getBounds().pad(0.15));
        } else if (cfg.center && cfg.center.lat && cfg.center.lng && cfg.center.zoom) {
            map.setView([cfg.center.lat, cfg.center.lng], cfg.center.zoom);
        } else {
            map.setView([52.2297, 21.0122], 6);
        }

        setTimeout(function () {
            map.invalidateSize();
            syncHeights($block, map);
        }, 0);

        if (window.ResizeObserver && $list.length) {
            var ro = new ResizeObserver(function(){ syncHeights($block, map); });
            ro.observe($list.get(0));
            $block.data('ro', ro);
        }

        $(window).on('resize.wbdmMap', debounce(function(){
            syncHeights($block, map);
        }, 150));

        if (markers.length === 1 && cfg.markers && cfg.markers[0] && cfg.markers[0].slug) {
            var onlySlug = String(cfg.markers[0].slug);
            if ($select.length) $select.val(onlySlug);
            focusDealer($block, map, bySlug, onlySlug);
        } else if (markers.length === 1) {
            if (icons) markers[0].setIcon(icons.goldActive);
            markers[0].openPopup();
            $block.data('activeMarker', markers[0]);
        }

        // Desktop list → focus
        $list.on('click', '.dealer-map__list-item', function () {
            var slug = String($(this).data('slug') || '');
            if (slug) focusDealer($block, map, bySlug, slug);
        }).on('keydown', '.dealer-map__list-item', function (e) {
            var key = e.key || e.keyCode;
            if (key === 'Enter' || key === ' ' || key === 13 || key === 32) {
                e.preventDefault();
                var slug = String($(this).data('slug') || '');
                if (slug) focusDealer($block, map, bySlug, slug);
            }
        });

        // MOBILE select → focus
        $select.on('change', function () {
            var slug = String($(this).val() || '');
            if (slug) focusDealer($block, map, bySlug, slug);
        });

        // URL params
        var params = new URLSearchParams(window.location.search);
        if (params.has('focus')) {
            var focusSlug = String(params.get('focus') || '').toLowerCase();
            if (focusSlug && bySlug[focusSlug]) focusDealer($block, map, bySlug, focusSlug);
        }
        if (params.has('navigate')) {
            var target = params.get('navigate');
            var chosen = null;
            if (target && target !== '1') {
                var s = String(target).toLowerCase();
                chosen = (cfg.markers || []).find(function (m) { return String(m.slug||'').toLowerCase() === s; });
            } else if ((cfg.markers || []).length === 1) {
                chosen = cfg.markers[0];
            }
            if (chosen && chosen.gmaps) { window.location.href = chosen.gmaps; }
        }
    }

    $(function () {
        $('.dealer-map__wrap').each(function () { initMap($(this)); });
    });
})(jQuery);
